<template>
	<section>
		<x-modal
			:wWidth="1080"
			v-if="isVisible"
			@cancel="closeNotes()"
			@close="closeNotes()"
			@ok="saveNote"
			:draggable="true"
			:resizable="true"
			:loading="noteLoading"
			:okDisabled="noteLoading"
			okText="Create Note"
			cancelText="Close"
		>
			<div slot="title" :class="`d-flex justify-content-between align-items-center`">
				<span v-if="isReferrer">All Notes {{ referrerName ? 'for ' + referrerName : '' }}</span>
				<span v-else>All Notes {{ customerName ? 'for ' + customerName : '' }}</span>
			</div>

			<div class="modal-content-container">
				<el-row :gutter="20">
					<el-col :span="12">
						<div class="section-title">
							<h3>Notes for Application #{{ application.ref_id }}</h3>
						</div>
						<el-container v-loading="notesRefreshing" class="notes-container">


							<div class="w-100" v-if="!_.isEmpty(appNotes)">
								<el-card shadow="hover" v-for="note in appNotes" :key="note.id">
									<div v-if="note.is_referrer_visible === 1 && isReferrer || !isReferrer">
										<div slot="header" class="clearfix">
											<small style="float: right">{{ note.user_name }}</small>
										</div>
										<div slot="header" class="clearfix">
											<span>{{ note.title }}</span>
											<small style="float: right">{{ formatDate(note.updated_at) }}</small>
										</div>
										<div class="text item">
											{{ note.notes }}
										</div>
									</div>
								</el-card>
							</div>


							<div style="padding: 10px; font-weight: 500; font-size: 14px" class="w-100" v-else>No Notes</div>
						</el-container>
					</el-col>
					<el-col :span="12">
						<div class="section-title">
							<h3>Create a Note</h3>
						</div>
						<el-container class="new-note-container">
							<el-form :rules="rules" ref="noteForm" :model="noteForm" label-position="top">
								<el-form-item prop="title" label="Title">
									<el-input v-model="noteForm.title" placeholder="Title"></el-input>
								</el-form-item>
								<el-form-item prop="note" label="Note">
									<el-input
										:autosize="{ minRows: 4, maxRows: 10 }"
										type="textarea"
										v-model="noteForm.note"
										placeholder="Note"
									></el-input>
								</el-form-item>
								<el-form-item>
									<el-checkbox :style=this.hideShare
										:checked="this.trigger === false ? false : true"
										:disabled="this.trigger === false ? false : true"
										v-model="noteForm.sharedWithReferrer"
										label="Share note with referral partner"
										border
									></el-checkbox>
								</el-form-item>
							</el-form>
						</el-container>
					</el-col>
				</el-row>
			</div>
		</x-modal>
	</section>
</template>

<script>
	import { mapGetters } from "vuex"
	export default {
		name: "NotesModal",
		props: ["visible", "isReferrer", "application", "token", "title"],
		data() {
			return {
				isVisible: false,
				notesRefreshing: true,
				noteLoading: false,
				appNotes: [],
				userRole: [],
				check: false,
				hideShare: "opacity: 100;",
				trigger: false,
				noteForm: {
					title: "",
					note: "",
					sharedWithReferrer: this.isReferrer ? true : false,
				},
				rules: {
					note: [{ required: true, message: "Note is Required", trigger: "blur" }],
				},
			}
		},
		computed: {
			...mapGetters({
				user: "user/user",
			}),
            customerName() {
                return _.get(this.application, 'customer_name', _.get(this.application, 'customer.full_name', ''))
            },
            referrerName() {
                return _.get(this.application, 'referrer_user.full_name', _.get(this.application, 'referrer_user', ''))
            },
		},
		watch: {
			visible(visible) {
				this.isVisible = visible
				if (visible) {
					this.refreshNotes()
				}
			},
            title: {
                handler(title) {
                    if (title) {
                        this.noteForm.title = title
                    }
                },
                immediate: true
            }
		},
		mounted() {

        },
		methods: {
			referrerCheck(){
				this.userRole = _.get(this.user, 'roles')
				this.userRole.forEach(name => {
					if(name.name === 'referrer'){
						this.trigger = true
						this.hideShare = "opacity: 0;"
					}
				})
			},
			formatDate(date) {
				return this.$moment.utc(date).tz(this.user.timezone).format("ddd DD/MM/YY LT")
			},
			closeNotes() {
				this.isVisible = false
				this.$emit("update:visible", false)
				this.appNotes = []
			},
			refreshNotes() {
				this.getAllNotesOfApp(this.application.id)
			},
			getAllNotesOfApp(applicationId = null) {
				this.referrerCheck()
				this.notesRefreshing = true
				if (applicationId) {
					let url = "/api/v2/notes/" + "?application_id=" + applicationId
					axios
						.get(url, {
							headers: {
								Authorization: "Bearer " + this.token,
							},
						})
						.then((res) => {
							this.appNotes = res.data
							this.notesRefreshing = false
						})
				}
			},

			saveNote() {
				this.$refs['noteForm'].validate((valid) => {
					if (valid) {
                        this.noteLoading = true
						axios
							.post(
								"/api/notes",
								{
									title: this.noteForm.title,
									notes: this.noteForm.note,
									application_id: this.application.id,
									is_referrer_visible: this.noteForm.sharedWithReferrer,
								},
								{
									headers: {
										Authorization: "Bearer " + this.token,
									},
								}
							)
							.then((res) => {
								this.noteForm = {
									title: "",
									note: "",
									sharedWithReferrer: this.isReferrer ? true : false,
								}
								this.noteLoading = false
								this.refreshNotes()
                                this.$store.dispatch("notes/saveNote", res.data);
							})
							.catch((err) => {
								console.error(err)
							})
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.el-form {
		width: 100%;
		padding: 10px;

		.el-form-item {
			.el-form-item__label {
				margin: 0 !important;
				padding: 0 !important;
			}

			.el-checkbox {
				background: #ffffff;
			}
		}
	}

    .modal-content-container {
        text-align: left;
        padding: 0 10px;
    }

	.section-title {
		margin: 20px 0;
		h3 {
			text-transform: none;
			font-size: 16px !important;
		}
	}

	.notes-container,
	.new-note-container {
		border: 1px solid #ebeef5;
		padding: 10px;
		background: #f9f9f9;
		height: 370px;
		overflow: scroll;
	}

	.el-card {
		width: 100%;
		margin-bottom: 10px;
		&:last-child {
			margin-bottom: 0;
		}
		.el-card__header {
			padding: 10px 20px 5px;
		}
	}
</style>
